(function workflowDefinition() {
    'use strict';
    angular.module('Entities')
        .service('workflowService', [
            'restUrlBuilder', function workflowService(restUrlBuilder) {
                this.get = function get() {
                    return restUrlBuilder.all('workflow/GetUserProcInstance')
                        .get();
                };

                this.startWorkFlow = function startWorkFlow(documentId, documentName, documentType, documentVersion) {
                    var params = {
                        DocumentId: documentId,
                        DocumentName: documentName,
                        DocumentType: documentType,
                        DocumentVersion: documentVersion
                    };

                    return restUrlBuilder.all('workflow/StartProcessInstance').post(params);
                };

                this.claimTask = function claimTask(selectedTask) {

                    var request = selectedTask.id;

                    return restUrlBuilder.all('workflow/ClaimTask').put(request);
                };

                this.getTask = function getTask(taskId, scope) {

                    var params = { taskId: taskId, scope: scope };


                    return restUrlBuilder.all('WorkFlow/getTask')
                        .get({ params: params });
                };

                this.getDocumentWorkFlows = function getDocumentWorkFlows(docId) {

                    var params = { documentId: docId };


                    return restUrlBuilder.all('WorkFlow/GetAllDocWorkflows')
                        .get({ params: params });
                };

                this.sendTask = function sendTask(selectedTask) {
                    return restUrlBuilder.all('WorkFlow/TaskAction').post(selectedTask);
                };
            }
        ]);
})();